import { httpFetch } from '../Utils/httpUtils';
import { feedbackActionTypes as actionTypes } from '../ActionTypes/feedbackActionTypes';
import { commonActionTypes } from '../ActionTypes/commonActionTypes';
import type { UpvoteResult } from '../Components/Feedback/Feedback.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;

const fetchWithLoading = (key: string, url: string, type: string) => {
    return (dispatch: AnyDispatch) => {
        dispatch({ type: commonActionTypes.SET_DATA_LOADING, key, value: true });
        return httpFetch(url, dispatch)
            .then((json: unknown) => {
                dispatch({ type, data: json });
            })
            .finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key, value: false });
            });
    };
};

const feedbackActions = {
    getFeedbackList: () => fetchWithLoading('feedbackList', '/api/Feedback/List', actionTypes.STORE_FEEDBACK_LIST),

    getMyFeedback: () => fetchWithLoading('myFeedback', '/api/Feedback/MyFeedback', actionTypes.STORE_MY_FEEDBACK),

    submitFeedback: (suggestion: string, isPublic: boolean) => {
        return (dispatch: AnyDispatch) => {
            return httpFetch('/api/Feedback/Submit', dispatch, {
                method: 'POST',
                body: JSON.stringify({ suggestion, isPublic }),
            });
        };
    },

    toggleUpvote: (suggestionId: number) => {
        return (dispatch: AnyDispatch) => {
            dispatch({ type: actionTypes.UPVOTE_STARTED, suggestionId });
            return httpFetch(`/api/Feedback/Upvote/${suggestionId}`, dispatch, { method: 'POST' })
                .then((result: UpvoteResult) => {
                    dispatch({ type: actionTypes.STORE_UPVOTE_RESULT, data: result });
                })
                .catch(() => {
                    dispatch({ type: actionTypes.UPVOTE_FAILED, suggestionId });
                });
        };
    },
};

export default feedbackActions;
